import { Badge, Box, Button, Popover, Typography } from "@mui/material";
import { useBreakpoints } from "../../../../hooks/useBreakpoins";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import useCart from "../../../../hooks/context/useCart";
import React from "react";
import { useBRLmoney } from "../../../../hooks/useBRLmoney";
import { grey } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import { CircularLoading } from "../../Atoms";
import useAuth from "../../../../hooks/context/useAuth";
import { colors } from "../../../../theme/colors";

export function CartPopover() {
  const navigate = useNavigate();
  const { isSmalldesktop } = useBreakpoints();
  const { cartDataMemo, loading } = useCart();
  const { user } = useAuth();
  const { BRLmoney } = useBRLmoney();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const data = cartDataMemo[0];

  const redirectToCheckout = () => {
    navigate("/checkout/mycart");
  };

  return (
    <>
      <Badge
        badgeContent={data?.totalItens}
        color="secondary"
        sx={{
          "& .MuiBadge-badge": {
            right: 2,
            top: 2,
            background: "#FFCB64",
            borderRadius: "50%",
            width: 30,
            height: 30,
            padding: "0 4px",
          },
        }}
      >
        <Button
          variant="text"
          onClick={(e) => {
            if (!user?.user) {
              navigate("/user/login");
            } else {
              if (isSmalldesktop) {
                redirectToCheckout();
              } else {
                handleClick(e);
              }
            }
          }}
          sx={{
            color: "#8960DF",
            "&:hover": { background: "#8960DF70" },
          }}
        >
          <ShoppingCartOutlinedIcon />
        </Button>
      </Badge>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box p={2}>
          {loading.cartLoading ? (
            <CircularLoading />
          ) : (
            <>
              <Button
                variant="contained"
                style={{ marginBottom: 10 }}
                onClick={redirectToCheckout}
                fullWidth
              >
                Carrinho <ShoppingCartCheckoutIcon sx={{ ml: 1 }} />
              </Button>

              <Box display={"flex"} flexDirection={"column"} gap={1}>
                {data?.cartXProduct?.map((item, index) => (
                  <Box
                    key={index}
                    display={"flex"}
                    onClick={() =>
                      navigate(`/details?product=${item?.product?.id}`)
                    }
                    sx={{
                      cursor: "pointer",
                      "&:hover": { background: grey[100], borderRadius: 2 },
                    }}
                  >
                    <img
                      src={item?.product?.productsImages[0]?.code}
                      style={{
                        objectFit: "contain",
                        width: 100,
                        height: 100,
                        borderRadius: 5,
                        background: grey[200],
                      }}
                      alt={item?.product?.name}
                    />

                    <Typography
                      maxWidth={250}
                      maxHeight={100}
                      overflow={"hidden"}
                      ml={1}
                    >
                      x{item?.quantity} -{" "}
                      {BRLmoney(item?.product?.price * item?.quantity)} -{" "}
                      {item?.product?.name}
                    </Typography>
                  </Box>
                ))}
                {data?.cartXProduct?.length === 0 && (
                  <Typography
                    textAlign={"center"}
                    m="25px 0px"
                    fontSize={18}
                    color={colors.purple[500]}
                    fontWeight={700}
                  >
                    Seu carrinho está vazio
                  </Typography>
                )}
              </Box>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
}
